/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderVo } from './OrderVo';
import {
    OrderVoFromJSON,
    OrderVoFromJSONTyped,
    OrderVoToJSON,
    OrderVoToJSONTyped,
} from './OrderVo';

/**
 * 
 * @export
 * @interface ResponseOrderVo
 */
export interface ResponseOrderVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderVo
     */
    message?: string;
    /**
     * 
     * @type {OrderVo}
     * @memberof ResponseOrderVo
     */
    data?: OrderVo;
}

/**
 * Check if a given object implements the ResponseOrderVo interface.
 */
export function instanceOfResponseOrderVo(value: object): value is ResponseOrderVo {
    return true;
}

export function ResponseOrderVoFromJSON(json: any): ResponseOrderVo {
    return ResponseOrderVoFromJSONTyped(json, false);
}

export function ResponseOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderVoFromJSON(json['data']),
    };
}

export function ResponseOrderVoToJSON(json: any): ResponseOrderVo {
    return ResponseOrderVoToJSONTyped(json, false);
}

export function ResponseOrderVoToJSONTyped(value?: ResponseOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderVoToJSON(value['data']),
    };
}

